<script>
  export default {
    name: 'ChangeCrypto',

    props: {
      value: {
        type: Boolean,
        required: true,
      },

      currency: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      showDialog: false,
    }),

    watch: {
      value: {
        immediate: true,
        handler(value) {
          this.showDialog = value;
        },
      },
    },

    methods: {
      async closeDialog(isConfirmed = false) {
        this.$emit(isConfirmed ? 'confirm' : 'deny');
        await this.$nextTick();
        this.showDialog = false;
        this.$emit('input', false);
      },

      cancel() {
        this.closeDialog(false);
      },

      confirm() {
        this.closeDialog(true);
      },

      getIconUrl(icon) {
        if (icon.includes('/images/coins')) return icon;
        return `/images/coins/${icon}?v=3`;
      },
    },
  };
</script>

<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    content-class="confirm-dialog alert-shadow rounded-borders-5"
    max-width="850px"
    @click:outside="closeDialog(false)"
    @keydown.esc="closeDialog(false)"
  >
    <v-card class="d-flex flex-column justify-center align-center position-relative py-6">
      <v-icon color="white" size="36" @click="closeDialog(false)">mdi-close</v-icon>

      <v-card-title class="justify-center px-5">
        <span class="white--text font-weight-bold">CHANGE CRYPTOCURRENCY</span>
      </v-card-title>
      <v-card-text class="white--text text-center font-size-20 font-weight-semi">
        <div>
          You have an open invoice for
          <img :src="getIconUrl(currency.icon)" alt="coin" class="ml-1" style="height: 20px" />
          <span class="font-weight-800 ml-2">{{ currency.text }}</span>
          .
        </div>
        <br />
        <div>
          Click
          <span class="gold--text font-weight-800">UPDATE</span>
          if you wish to proceed with the change.
        </div>
        <br />
        <div>
          BTC, USD, and altcoins will be exchanged at the most current rates,
          <br />
          with a guaranteed exchange rate for 20 minutes.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn class="confirm-btn red-bright font-size-18 font-weight-superbold text-capitalize" @click="cancel">
          CANCEL
        </v-btn>
        <v-btn class="green font-size-18 font-weight-superbold text-capitalize" @click="confirm">UPDATE</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
  .confirm-dialog {
    .v-card {
      .v-icon {
        position: absolute;
        right: 15px;
        top: 10px;
      }

      .v-card__actions {
        gap: 25px;
      }

      .v-btn {
        width: 150px;
        border-radius: 10px;
        color: white;
      }
    }

    .v-card__title {
      width: 100%;

      span {
        font-size: clamp(20px, 6vw, 28px);
        text-align: center;
        word-break: break-word;
      }
    }
  }
</style>
